import { render, staticRenderFns } from "./chicklet.vue?vue&type=template&id=10af28a2&"
import script from "./chicklet.vue?vue&type=script&lang=ts&"
export * from "./chicklet.vue?vue&type=script&lang=ts&"
import style0 from "./chicklet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports